import React, { useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";
import styled from "styled-components";
import {
  CATEGORIES_LIST_SPLINE_CHART,
  COLORS_LIST_SPLINE_CHART,
  DATA_LIST_SPLINE_CHART,
  MAX_VALUE_SPLINE_CHART,
  MIN_VALUE_SPLINE_CHART,
} from "../../utilities/constants";

// Styled components for styling
const ChartContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  min-width: 250px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 15px;
`;

const ChartWrapper = styled.div`
  width: 100%;
`;

const ApexChart = ({
  categoriesList,
  colorsList = COLORS_LIST_SPLINE_CHART,
  dataList = DATA_LIST_SPLINE_CHART,
  minValue = MIN_VALUE_SPLINE_CHART,
  maxValue = MAX_VALUE_SPLINE_CHART,
}) => {
  const options = useMemo(
    () => ({
      chart: {
        id: "realtime",
        height: 350,
        type: "line",
        animations: {
          enabled: true,
          easing: "linear",
          dynamicAnimation: {
            speed: 1000,
          },
        },
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },

      markers: {
        size: 0,
      },
      xaxis: {
        categories: categoriesList,
        labels: {
          style: {
            fontSize: "12px",
            fontFamily: "Helvetica, Arial, sans-serif",
          },
          step: 1,
        },
      },
      yaxis: {
        min: minValue,
        max: maxValue,
        tickAmount: 5,
      },
      legend: {
        show: true,
        position: "top",
        horizontalAlign: "right",
        onItemClick: {
          toggleDataSeries: false,
        },
      },
      colors: colorsList, // Green for Income, Red for Expense
    }),
    [categoriesList, colorsList, dataList, minValue, maxValue]
  );

  return (
    <ChartContainer>
      <ChartWrapper>
        <ReactApexChart
          options={options}
          series={dataList}
          type="line"
          height={350}
        />
      </ChartWrapper>
    </ChartContainer>
  );
};

export default ApexChart;
